import Crud from '../components/Promotional/Crud'
import Add from '../components/Promotional/Add'
import Edit from '../components/Promotional/Edit'

let routes = {
    path: '/promotional',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/promotional',
            component: Crud
        },
        {
            path: '/promotional/add',
            component: Add
        },
        {
            path: '/promotional/edit/:id',
            component: Edit
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/promotional.js